export const toastSuccessStyle = {
  'abyss-toast-description': {
    marginTop: 0,
  },
  'abyss-toast-close-button': {
    marginTop: '8px',
  },
};
